import * as React from 'react';
import { useStyles } from './styles';
import { Typography } from '@/components';

export const Modal = ({
  title,
  show,
  closeHandler,
  children
}: {
  title?: string;
  show: boolean;
  closeHandler: () => void;
  children: React.ReactElement;
}) => {
  const styles = useStyles();

  return (
    <div className={`${styles.modalWrapper} ${show && styles.showModal}`}>
      <div className={styles.content}>
        {title && <Typography component="h2">{title}</Typography>}
        <div className={styles.closeButton} onClick={closeHandler}>
          <span />
        </div>
        {children}
      </div>
    </div>
  );
};
